import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosClient from "../../axios-client";

function ResetPassword() {
  const { User } = useContext(AuthContext);
  const [ErrorMessage, setErrorMessage] = useState("");

  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false)

  const inputRef = useRef(null);

  const onSubmit = ev => {
    setIsLoading(true)
    ev.preventDefault();
    if (email === "") {
      toast.warning("Veuillez entrer votre adresse email", {
        position: "top-right",
        autoClose: 3000,
      });
      setIsLoading(false)
    } else {
      axiosClient.get('reset_email_client/', { params: { email: email } })
        .then((response) => {
          if (response.status === 203) {
            toast.info(response.data.message, {
              position: "top-right",
              autoClose: 3000,
            });
            setIsLoading(false)
          } else {
            toast.info("Un e-mail de réinitialisation de mot de passe a été envoyé, vérifiez votre boîte de réception", {
              position: "top-right",
              autoClose: 5000,
            });
            setEmail('')
            setIsLoading(false)
            // navigate('/signin')
          }

        })
        .catch((err) => {
          toast.error("Une erreur s'est produite.", {
            position: "top-right",
            autoClose: 3000,
          });
          setIsLoading(false)
          // console.error(err);
        });
    }
  };

  return (
    <div>
      <div
        className="flex h-screen justify-center items-center"
        style={{
          background: `url(${WelcomePageBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <ToastContainer />
        <div className=" p-5 md:p-12 rounded-md">
          <div className="py-10 flex justify-center items-center ">
            <img
              className="h-10 cursor-pointer w-18"
              src={logo}
              alt="NETFLIX"
            />
          </div>
          <h1 className=" text-md text-white mb-5">
            Générer un nouveau mot de passe
          </h1>

          <div>
            <input
              type="email"
              name="email"
              id="email"
              value={email}
              className={
                ErrorMessage
                  ? "mb-10 bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 border-2 border-red-700  dark:placeholder-white dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                  : "mb-10 bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
              }
              placeholder="Email"
              required=""
              onChange={(e) => setEmail(e.target.value)}
            ></input>
          </div>
          <div className="w-[100%] flex items-center justify-center">
            <button disabled={isLoading} onClick={onSubmit} style={{
              background: "linear-gradient(to right, #eb6820, #fd9358)",
            }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md   md:text-md flex items-center justify-center ">
              Générer un mot de passe
            </button>

          </div>
          <Link to={"/signin"}>
            <h1 className=" hover:underline text-center text-sm font-semibold leading-tight tracking-tight py-5 text-white">
              Se connecter
            </h1>

          </Link>


        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
